import { render, staticRenderFns } from "./KPIFormatPicker.vue?vue&type=template&id=3da24c76&scoped=true"
import script from "./KPIFormatPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIFormatPicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KPIFormatPicker.vue?vue&type=style&index=0&id=3da24c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da24c76",
  null
  
)

export default component.exports